/**
 * @author NikolaV
 */

import * as React from 'react';
import { FileTreeService } from '@shared/services/FileTreeService';


export class FiletreeSelect extends React.PureComponent<{
    name: string
    filetreeData: ITreeData,
    includeFiles?: boolean,
    filter?: (item) => boolean,
    firstEmpty?: boolean,
    firstEmptyText?: string,
    includeRoot?: boolean,
    hideEmptyFolders?: boolean,
    defaultValue?: any,
    value?: any,
    onChange?: (value) => void
    returnValueUuid?: boolean;
}, {}> {
    render() {
        const tree = FileTreeService.flattenFiletree(this.props.filetreeData, this.props.includeFiles, this.props.includeRoot, this.props.hideEmptyFolders, this.props.filter);
        const returnFileUuid = this.props.returnValueUuid;

        return (
            <select defaultValue={this.props.defaultValue} value={this.props.value} name={this.props.name} onChange={this.handleOnChange}>
                {this.props.firstEmpty ?
                    <option value={returnFileUuid?'':-1}>{this.props.firstEmptyText || '---'}</option> : null
                }

                {tree.nodes.map(item => {
                        const text = Array(item.depth * 4).join('\u00a0') + item.text; // indent with whitespace + node text

                        if (this.props.includeFiles && item.type === 'folder') {
                            return <option key={item.id}
                                           disabled={true}
                                           value={returnFileUuid?item.uuid:item.id}
                                           style={{ color: 'grey' }}>
                                {text}
                            </option>;
                        }
                        else {
                            return <option key={item.id}
                                           value={returnFileUuid?item.uuid: item.id}
                                           style={{ fontWeight: this.props.includeFiles ? 'bold' : 'normal' }}>
                                {text}
                            </option>;
                        }
                    },
                )}
            </select>
        );
    }

    handleOnChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(e.currentTarget.value);
        }
    };
}

